import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireJspredictDc } from "D:\\work\\openSource\\jspredict-dc\\jspredict-dc.js";
var jspredictDcExports = requireJspredictDc();
export { jspredictDcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(jspredictDcExports);